/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_decrease_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the percentage decrease formula?`)
};

const es_pct_decrease_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la fórmula de la disminución porcentual?`)
};

const de_pct_decrease_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lautet die Formel für den prozentualen Rückgang?`)
};

const nl_pct_decrease_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is de formule voor percentagedaling?`)
};

const fr_pct_decrease_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la formule de la diminution en pourcentage ?`)
};

const it_pct_decrease_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la formula del calo percentuale?`)
};

const pt_br2_pct_decrease_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a fórmula da diminuição percentual?`)
};

const pt_pct_decrease_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a fórmula da diminuição percentual?`)
};

const ja_pct_decrease_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント減少の計算式は？`)
};

const zh_pct_decrease_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比减少公式是什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_decrease_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_decrease_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_decrease_faq1_q", locale)
	if (locale === "en") return en_pct_decrease_faq1_q(inputs)
	if (locale === "es") return es_pct_decrease_faq1_q(inputs)
	if (locale === "de") return de_pct_decrease_faq1_q(inputs)
	if (locale === "nl") return nl_pct_decrease_faq1_q(inputs)
	if (locale === "fr") return fr_pct_decrease_faq1_q(inputs)
	if (locale === "it") return it_pct_decrease_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_decrease_faq1_q(inputs)
	if (locale === "pt") return pt_pct_decrease_faq1_q(inputs)
	if (locale === "ja") return ja_pct_decrease_faq1_q(inputs)
	return zh_pct_decrease_faq1_q(inputs)
};